<template>
  <div>
    <v-container>
      <v-layout row>
        <v-icon @click="goBack">arrow_back</v-icon>
      </v-layout>
      <student-info v-bind:initialStudent="student"></student-info>
      <v-btn small color="error" @click="deleteStudent">Delete Student</v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import StudentInfo from "./StudentInfo";

export default {
  components: {
    StudentInfo
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      student: "getStudent"
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    deleteStudent() {
      this.$confirm("Are you sure you want to delete this student?").then(
        res => {
          if (res) {
            this.$store.dispatch("deleteStudent", this.student).then(() => {
              this.$router.push({ path: "/Students/Summary" });
            });
          }
        }
      );
    }
  }
};
</script>

<style>
</style>